import React, { useEffect } from 'react';
import { WeddingBandsDecor } from '../WeddingBandsDecor.jsx';
import { playOpening } from '../../utils/sound.jsx';
import { OpeningReveal } from '../landing/landingBits.jsx';
import { icsUtcToMs, allDayTitleFor } from '../landing/phase.js';
import { HomeInvitation } from '../landing/HomeInvitation.jsx';
import { HomeDayOf } from '../landing/HomeDayOf.jsx';

// The hub takes over from the final few days onward — before that the page
// stays the invitation guests have been visiting all along.
const HUB_PHASES = new Set(['approaching', 'eventday', 'live', 'after']);

// The home page — one page in five states, driven by how close the wedding is
// (see landing/phase.js). Months out it's the invitation and the game; on a
// day with events it becomes the hub; afterwards it points at the gallery.
export function WelcomeScreen({ isDarkMode, phase, events, now, onStartGame, onNavigate }) {
  // Warm the game chunk so the Start button doesn't pay a network/parse cost.
  useEffect(() => {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
    const handle = idle(() => {
      import('./GameScreen.jsx');
    });
    return () => {
      if (window.cancelIdleCallback && typeof handle === 'number') {
        window.cancelIdleCallback(handle);
      }
    };
  }, []);

  const currentEvent =
    phase === 'live' && events
      ? events.find(
          (e) =>
            !e.allDay && now >= icsUtcToMs(e.startUtc) && now < icsUtcToMs(e.endUtc),
        )
      : null;

  // Names the day from the calendar's all-day entry, so the hub can say
  // "Today is Melse" rather than something generic.
  const todayTitle = allDayTitleFor(now, events);

  const handleStartGame = () => {
    // Fire the opening swell from this gesture so the audio context is
    // unlocked and it lands with the sun/moon rising on the game screen — not
    // deferred to the first later interaction.
    playOpening();
    onStartGame();
  };

  return (
    <>
      <div
        className={`fixed inset-0 w-screen h-screen z-50 flex flex-col items-center justify-start md:justify-center px-4 pt-28 pb-12 md:py-12 overflow-y-auto transition-colors duration-700 ${
          isDarkMode
            ? 'bg-slate-950 text-white'
            : 'bg-gradient-to-br from-slate-50 via-purple-50/40 to-pink-50/40 text-slate-900'
        }`}
      >
        <WeddingBandsDecor isDarkMode={isDarkMode} />

        {HUB_PHASES.has(phase) ? (
          <HomeDayOf
            isDarkMode={isDarkMode}
            phase={phase}
            currentEvent={currentEvent}
            todayTitle={todayTitle}
            onNavigate={onNavigate}
            onStartGame={handleStartGame}
          />
        ) : (
          <HomeInvitation
            isDarkMode={isDarkMode}
            onStartGame={handleStartGame}
            onNavigate={onNavigate}
          />
        )}
      </div>

      <OpeningReveal isDarkMode={isDarkMode} />
    </>
  );
}
